export const pathNamePages = {
  analisisDeudaCliente: "/analisisDeudaCliente",
  analisisDeudaProveedor: "/analisisDeudaProveedor",
  home: "/",
  cliente: '/cliente',
  proveedor: '/proveedor',
};
